<template>
    <Dialog :visible.sync="showDialog" :style="{ width: '900px' }" header="Detalhes do local de prova" :modal="true" @hide="hideDialog">
      <Message v-for="msg of messagesCadastroLocal" :severity="msg.severity" :key="msg.content">
        {{ msg.content }}
      </Message>

      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-12">
          <label for="nome" class="font-bold required">Escola</label>
          <ValidationProvider name="nome" rules="required" v-slot="{ errors }" mode="lazy">
            <InputText id="nome" v-model.lazy="localProva.nome" type="text" />
            <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
          </ValidationProvider>
        </div>

        <div class="field col-12 md:col-12">
          <CardEndereco :endereco="localProva.endereco" />
        </div>

        <div class="field col-12 md:col-12">
          <label class="col-12 md:col-6 font-bold required">
            Áreas do Processo Seletivo
          </label>
          <PickList v-model="areasSelecao" dataKey="id">
              <template #sourceheader>
                  Disponíveis
              </template>
              <template #targetheader>
                  Selecionadas
              </template>
              <template #item="slotProps">
                  <span>{{slotProps.item.area.nome}}</span>
              </template>
          </PickList>
        </div>

        <div class="field col-12 md:col-9">
          <label for="file_andares_salas" class="col-12 md:col-6 font-bold required">
            Estrutura (andar/sala/lugares/individual) [*.xslx]
          </label>
          <input
            id="file_andares_salas"
            icon="pi pi-upload"
            class="p-button-info"
            type="file"
            @change="onFileSelected"
            required="true"
            ref="file_andares_salas"
          />
        </div>
        <div class="field col-12 md:col-2">
          <Button
            label="Baixar Modelo"
            icon="pi pi-download"
            style="width: 150px"
            @click="downloadModelo('modelo de estrutura da escola')"
            class=" p-button-outlined p-button-secondary"
          ></Button>
        </div>
        <!-- <div class="field col-12 md:col-12 grid">
          <h6 class="field ml-3 mr-2  min-w-min font-bold ">
            Quantidade de salas individuais necessárias:
          </h6>
          <span> <Badge :value="salasIndividuais == 0 ? '0': salasIndividuais" severity="info"></Badge> </span>
        </div> -->
      </div>

      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancelarEdicao"/>
        <Button
          label="Salvar"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"/>
      </template>
    </Dialog>
</template>

<script>

import { validacaoFormulario } from '@/validacaoFormulario'
import { tratamentoDeErros } from "@/tratamentoDeErros";
import InscricaoService from '../../service/InscricaoService';
import LocalProvaService from "../../service/LocalProvaService";
import CardEndereco from "../CardEndereco.vue";

export default {
    mixins: [tratamentoDeErros, validacaoFormulario],

    components: { CardEndereco},
    props: {
      cadastroEscolaDialog: null,
      localProvaEdicao: null,
      processo: null,
      editar: { default:false },
      onAtualizarLista: Function,
    },
    data() {
        return {
          messagesCadastroLocal: [],
          habilitaInscricoes: false,
          inscricaoService: null,
          estadoInscricaoService: null,
          areasSelecao: [],
          distribuicaoConcluida: true,
          localProvaAreas: [],
          distribuicoes: [],
          selectedSala: null,
          showDialog: false,
          // estrutura objetos
          localProva: {},
          salasIndividuais: 0,
          flagEditar: false,
          errors: [],
        };
    },
    created() {
        this.inscricaoService = new InscricaoService();
        this.localProvaService = new LocalProvaService();
    },
    mounted() {
        this.distribuicoes = this.localProva.andares;
    },
    watch :{
      cadastroEscolaDialog: function(val) {
        this.showDialog = val;
      },
      localProvaEdicao: function(val) {
        this.localProva = JSON.parse(JSON.stringify(val));
        let selecaoAreaIds = [];
        console.log(this.localProva);
        let areasDisponiveis = this.processo.selecaoEstagioArea.filter( a => {
            let selecionado = this.localProva.areasLocalProva.length > 0 && this.localProva.areasLocalProva.some( l => l.id == a.id );
            if (selecionado) { selecaoAreaIds.push(a.id); }
            return !selecionado;
            });
        this.areasSelecao = [areasDisponiveis, this.localProva.areasLocalProva];
        this.contarSalasIndividuais(selecaoAreaIds);
        this.flagEditar = (this.localProva.id != null);
      },
      areasSelecao() {
        let selecaoAreaIds = [];
        this.areasSelecao[1].forEach( a => {
            selecaoAreaIds.push(a.id);
          });
        console.log(this.areasSelecao);
        this.contarSalasIndividuais(selecaoAreaIds);
      }
    },
    methods: {
      onFileSelected(event) {
        console.log("onFileSelected file_andares_salas...");
        //this.$refs.file_andares_salas.value="";

        this.messages = [];
        this.localProva.fileAndaresSalas = null;
        this.localProva.fileAndaresSalas = event.target.files[0];
        var fileUpload = document.getElementById("file_andares_salas");

        console.log("fileUpload.value ...", fileUpload.value);
        if (!fileUpload.value.endsWith(".xlsx")) {
          this.fileAndaresSalas = null;
          fileUpload.value = "";
          this.messagesCadastroLocal = [
            {
              severity: "error",
              content: "Somente arquivos do tipo *.xlsx são permitidos",
            },
          ];
        }
      },
      hideDialog() {
        this.$emit('update:cadastroEscolaDialog', false);
        this.showDialog = false;
        this.messagesCadastroLocal = [];
      },
      save() {
        this.messagesCadastroLocal = [];
        this.aguardeDialog = true;
        console.log("cadastrarLocalProva...");
        const fd = new FormData();
        fd.append("selecaoEstagioId", this.processo.id);
        fd.append("nome", this.localProva.nome);
        fd.append("cep", this.localProva.endereco.cep);
        fd.append("logradouro", this.localProva.endereco.logradouro);
        fd.append("numero", this.localProva.endereco.numero);
        fd.append("complemento", this.localProva.endereco.complemento);
        fd.append("bairro", this.localProva.endereco.bairro);
        fd.append("cidade", this.localProva.endereco.cidade.nome);
        fd.append("uf", this.localProva.endereco.cidade.estado.uf);

        if (this.localProva.fileAndaresSalas) {
          fd.append("andaresSalas", this.localProva.fileAndaresSalas);
        } else {
          //  fd.append("andaresSalas", null);
        }

        console.log("Local Prova", this.localProva);
        //if (this.localProva.id) {
        if (this.flagEditar) {
          fd.append("id", this.localProva.id);
          fd.append("idEndereco", this.localProva.endereco.id);
        } else if (this.localProva.fileAndaresSalas == null) {
          this.messagesCadastroLocal = [
            { severity: "error", content: "Arquivo de estrutura é obrigatório" },
          ];
        }

        // tratando áreas para loca de prova
        this.localProvaAreas = this.areasSelecao[1];
        console.log(this.localProvaAreas);
        if (this.localProvaAreas != null && this.localProvaAreas.length > 0) {
          let idAreasSelecao = [];
          this.localProvaAreas.forEach(element => {
              idAreasSelecao.push(element.id) ;
            });
          fd.append("idAreasSelecao", idAreasSelecao);
          console.log("fd final", fd);
        } else {
          this.messagesCadastroLocal = [{ severity: "error", content: "É necessário informar áreas para o local de prova." }];
        }

        if (this.messagesCadastroLocal.length > 0) return;

        this.localProvaService.createOrUpdate(fd, this.flagEditar)
          .then(() => {
            this.hideDialog();
            this.aguardeDialog = false;
            this.$toast.add({
              severity: "success",
              summary: "Sucesso",
              detail: `Local de Prova salvo com sucesso`,
              life: 5000,
            });

            this.atualizarLocaisProva();
          })
          .catch((erro) => {
            console.error("erro dado", erro.response.data.status);
            let listaErros = [];
            if (erro.response.data.status == 400) {
              listaErros = this.getMessagesErrorLocalProva(erro);
              // this.messagesCadastroLocal.push(this.getMessagesErrorLocalProva(erro));
            } else {
              listaErros = this.getMessagesError(erro);
              // this.messagesCadastroLocal.push(this.getMessagesError(erro));
            }

            listaErros.forEach( e => this.messagesCadastroLocal.push(e));

            this.aguardeDialog = false;
            const input = this.$refs.file_andares_salas;
            input.type = "text";
            input.type = "file";
          });
      },
      downloadModelo() {
        this.localProvaService.getDownloadModelo();
      },
      atualizarLocaisProva() {
        if (this.onAtualizarLista) {
          this.onAtualizarLista(this.processo.id);
        }
      },
      contarSalasIndividuais(selecaoAreaIds) {
        this.localProvaService.getQuantidadeSalasIndividuaisPorArea(this.processo.id, selecaoAreaIds)
            .then((resposta) => {
                console.log("contador", resposta);
                this.salasIndividuais = resposta.salasIndividuais;
            });
      },
      cancelarEdicao(){
        this.hideDialog();
        this.localProva = JSON.parse(JSON.stringify(this.localProvaEdicao));
      }
    },

};

</script>

<style>
</style>
